// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".post-avatar[data-v-31d2cc7b]{padding:5px 10px 10px 5px;height:52px;width:52px}", "",{"version":3,"sources":["webpack://./src/components/TimelineAvatar.vue"],"names":[],"mappings":"AACA,8BACC,yBAAA,CACA,WAAA,CACA,UAAA","sourcesContent":["\n.post-avatar {\n\tpadding: 5px 10px 10px 5px;\n\theight: 52px;\n\twidth: 52px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
